declare const __APP_VERSION__: string | undefined;

/**
 * Current release version, injected at build time from the latest
 * CHANGELOG.md entry (see vite.config.ts define). Empty string in
 * environments without the define (vitest), which hides the badge.
 */
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '';
